import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Functional Usage: A classification of space based on its primary function, such as research, instruction, or administration used in indirect rate proposal.',
    name: 'Space Functional Usages',
    partialId: PartialId.Standard.create('func_space'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
